import {
  BookOurService,
  HowItWorksSection,
  OurProductsSection,
} from "shared/sections";

const OurProducts = () => (
  <>
    <OurProductsSection />
    <HowItWorksSection />
    <BookOurService />
  </>
);

export default OurProducts;
